import captureError from '@disco/utils/captureError'

import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { scheduleSendEmailCampaign } from '@disco/state-management/actions/campaign-details-actions'
import {
  getCampaignSchedule,
  isCampaignSendAllowed,
} from '@disco/state-management/selectors/campaigns'
import mixpanel from '@disco/api/mixpanel'
import { EmailSchedulerModal } from 'components/modals/email-scheduler'

const EmailSchedulerPage = (): React.ReactNode | React.ReactElement<'div'> => {
  const params = useParams<{ campaignId: string }>()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [rescheduleData, setRescheduleData] = useState(false)
  const storedCampaignSchedule = useSelector(state =>
    getCampaignSchedule(state, Number(params.campaignId)),
  )
  const campaignSendAllowed = useSelector(state =>
    isCampaignSendAllowed(state, params.campaignId!),
  )
  const handleOnClose = useCallback(() => {
    if (
      storedCampaignSchedule &&
      storedCampaignSchedule.status === 'scheduled'
    ) {
      mixpanel.sendPureEvent('Email Creator - Reschedule email', {
        Context: 'Email',
      })
    } else {
      mixpanel.sendPureEvent('Email Creator - Schedule email')
    }
    navigate(`/campaigns/${params.campaignId}/confirm`)
  }, [params.campaignId, storedCampaignSchedule])
  useEffect(() => {
    if (!campaignSendAllowed) {
      handleOnClose()
    }

    if (storedCampaignSchedule) {
      setRescheduleData(true)
    }
  }, [campaignSendAllowed])

  const handleScheduleData = data => {
    try {
      dispatch(
        scheduleSendEmailCampaign(
          Number(params.campaignId),
          data,
          rescheduleData,
        ),
      )
    } catch (error) {
      captureError(error)
    }
  }

  return (
    <EmailSchedulerModal
      setScheduleData={handleScheduleData}
      onClose={handleOnClose}
      storedCampaignSchedule={storedCampaignSchedule}
      caption="Schedule email"
      description="Pick a date, time and timezone for your email to go out."
      primaryButtonCaption="Schedule"
    />
  )
}

export default EmailSchedulerPage
